import React from "react";
import { Container, Typography, CardContent, Card } from "@mui/material";

const EmailNotVerified: React.FC = () => {
  return (
    <Container maxWidth="md">
      <Card variant='outlined'>
        <CardContent>
          <Typography variant="h5" style={{marginBottom:"30px"}}>Email verification required</Typography>
          <Typography variant="body1" style={{marginBottom:"30px"}}>We've sent a verification email to your registered email address. 
            Please check your inbox and click the verification link to access this content.</Typography>
        </CardContent>
      </Card>
    </Container>
  );
};

export default EmailNotVerified;
